// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileHeader-modulenewBadge__Q6GLV";
var _2 = "RentalPortalApplicantProfileHeader-modulestageSelect__AZ6wx";
export { _1 as "newBadge", _2 as "stageSelect" }
